import { render, staticRenderFns } from "./EditBucket.vue?vue&type=template&id=9f0b15c2&scoped=true&"
import script from "./EditBucket.ts?vue&type=script&lang=ts&"
export * from "./EditBucket.ts?vue&type=script&lang=ts&"
import style0 from "./EditBucket.vue?vue&type=style&index=0&id=9f0b15c2&scoped=true&lang=css&"
import style1 from "./EditBucket.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0b15c2",
  null
  
)

export default component.exports